export const gptMetricCodeTranslate: Record<number, string> = {
  200: 'Действие успешно выполнено.',
  300: 'Метрика не рассчитывалась, т.к. не сработало условие запуска её расчёта.',
  400: 'Ошибка валидации ответа метрики.',
  500: 'Ошибка при расчёте метрики.',
  501: 'Не удалось посчитать метрику из-за ошибки запроса к GPT сервису.',
  502: 'Результат по метрике отсутствует в ответе GPT.',
  800: 'Не удалось посчитать группу метрик (одна или несколько посчитаны с ошибкой).',
  801: 'Не удалось посчитать группу метрик из-за ошибки запроса к GPT сервису.',
  901: 'Не удалось отправить запрос на GPT (запрос вернул ошибку).',
};
